<template>
  <pict
    class="m-auto z-50 flex justify-center"
    block-name="people-spider-image"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "../images/people_spider.png"
import imageL2x from "../images/people_spider@2x.png"
import imageS from "../images/people_spider_s.png"
import imageS2x from "../images/people_spider_s@2x.png"

export default {
  name: "PeopleSpiderImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "Book covers for 'Sapiens', 'Atomic Habits', and 'The 5am Club' and people's faces connected by lines."
      },
      de: {
        alt: "Buch Vorderseiten von 'Sapiens', 'Atomic Habits' und 'The 5am Club' und Gesichter von Personen, die mit Linien verbunden sind."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.book-share {
  ::v-deep &__image {
    width: auto;
  }
}
</style>
